module.exports = __webpack_public_path__ + "img/hamburguer.b799a0d7.svg";